import Yup from '../../../yup-extended';

export default Yup.object({
  name: Yup.string().required('Please enter a name'),
});
